import { render, staticRenderFns } from "./SampleLedger.vue?vue&type=template&id=7779fe74&scoped=true"
import script from "./SampleLedger.vue?vue&type=script&lang=js"
export * from "./SampleLedger.vue?vue&type=script&lang=js"
import style0 from "./SampleLedger.vue?vue&type=style&index=0&id=7779fe74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7779fe74",
  null
  
)

export default component.exports